"use strict";

module.exports = function havePropsChanged(prevProps, nextProps, keys) {
  var changedProps = [];
  keys.forEach(function (key) {
    if (prevProps[key] != nextProps[key]) {
      changedProps.push(key);
    }
  });
  return changedProps;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-qr-reader/lib/havePropsChanged.js
// module id = 847
// module chunks = 0